module.exports = __webpack_public_path__ + "static/img/my account_recharge_unionpay@2x.b725ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pics/my account_recharge_unionpay@2x.png
// module id = n+G6
// module chunks = 1